<!-- stopPropagation: a tap on the card opens the listing, not the bubble's long-press menu or swipe. -->
<a
  *ngIf="!listing.deleted; else gone"
  [routerLink]="link"
  class="flex items-center gap-2 rounded-lg bg-white/60 p-1.5 text-left no-underline hover:bg-white/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
  [attr.aria-label]="'About: ' + title + (price ? ', ' + price : '') + (listing.sold_at ? ', sold' : '') + '. Open it'"
  (click)="$event.stopPropagation()"
>
  <ng-container *ngTemplateOutlet="body"></ng-container>
</a>

<ng-template #gone>
  <div class="flex items-center gap-2 rounded-lg bg-white/40 p-1.5 text-left opacity-80">
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </div>
</ng-template>

<ng-template #body>
  <img *ngIf="photo; else noPhoto" [src]="photo" alt="" class="size-10 shrink-0 rounded object-cover" />
  <ng-template #noPhoto>
    <span class="flex size-10 shrink-0 items-center justify-center rounded bg-black/5 text-gray-500" aria-hidden="true">
      <mat-icon class="!size-5 !text-[20px]">{{ placeholderIcon }}</mat-icon>
    </span>
  </ng-template>
  <span class="min-w-0 flex-1 leading-tight">
    <span class="block text-[10px] font-medium uppercase tracking-wide text-gray-600">About</span>
    <span class="block truncate text-xs font-semibold text-gray-900">{{ title }}</span>
    <span class="block text-xs text-gray-700">
      <ng-container *ngIf="listing.deleted; else live">No longer listed</ng-container>
      <ng-template #live>
        {{ price }}
        <span *ngIf="listing.sold_at" class="ml-1 rounded bg-gray-800 px-1 py-px text-[10px] font-semibold uppercase text-white">Sold</span>
      </ng-template>
    </span>
  </span>
</ng-template>
